/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */
'use es6';

import * as client from 'DesignData/api/RawAssetBuffers';
import { fetchRawAssetRevision, revertRawAsset as revertRawAssetClient } from 'DesignData/api/Revisions';
import { getRawAsset } from 'DesignData/selectors/rawAssetBuffers';
import * as RawAssetExtensions from 'DesignData/enums/RawAssetExtensions';
import { TEXT } from 'DesignData/enums/RawAssetTypes';
import { RAW_ASSET_BUFFER_FETCH, RAW_ASSET_BUFFER_FETCH_BY_PATH, RAW_ASSET_BUFFER_SAVE, RAW_ASSET_BUFFER_SAVE_BY_PATH, RAW_ASSET_BUFFER_UPDATE_SOURCE, RAW_ASSET_BUFFER_JSON_LINT, RAW_ASSET_BUFFER_REPLACE, RAW_ASSET_REVERT, RAW_ASSET_REVISION_FETCH, RAW_ASSET_UPDATE_UPLOAD_PROGRESS } from 'DesignData/actions/ActionTypes';
import { DIFFERENT_FILE_EXTENSION } from 'DesignData/enums/ErrorTypes';
import { STAGED } from 'DesignData/enums/StagingEnvironments';
import { MYSQL } from 'DesignData/enums/AssetSources';
import { formatPathAsId } from 'DesignData/lib/text';
import { addStagedFile } from 'DesignData/actions/Staging';

const processRawAsset = rawAsset => {
  if (rawAsset.assetSource && rawAsset.assetSource !== MYSQL) {
    rawAsset = Object.assign({}, rawAsset, {
      id: formatPathAsId(rawAsset.path),
      folderId: formatPathAsId(rawAsset.folderPath)
    });
  }

  return rawAsset;
};

const messageFactory = type => (rawAssetId, fields) => Object.assign({
  type,
  rawAssetId
}, fields);

export const fetch = rawAssetId => {
  const fetchMessage = messageFactory(RAW_ASSET_BUFFER_FETCH);
  return dispatch => {
    dispatch(fetchMessage(rawAssetId));
    return client.fetch(rawAssetId).then(rawAsset => {
      rawAsset = processRawAsset(rawAsset);
      return dispatch(fetchMessage(rawAsset.id, {
        rawAsset
      }));
    }).catch(error => {
      dispatch(fetchMessage(rawAssetId, {
        error
      }));
    });
  };
};
export const fetchByPath = rawAssetId => {
  const fetchMessage = messageFactory(RAW_ASSET_BUFFER_FETCH_BY_PATH);
  return dispatch => {
    dispatch(fetchMessage(rawAssetId));
    client.fetchByPath(rawAssetId).then(rawAsset => {
      rawAsset = processRawAsset(rawAsset);
      dispatch(fetchMessage(rawAsset.id, {
        rawAsset
      }));
    }).catch(error => {
      dispatch(fetchMessage(rawAssetId, {
        error
      }));
    });
  };
};
/**
 * @param {number} rawAssetId
 * @param {string} source
 */

export function updateSource(rawAssetId, source) {
  return {
    type: RAW_ASSET_BUFFER_UPDATE_SOURCE,
    rawAssetId,
    source
  };
}
const saveMessage = messageFactory(RAW_ASSET_BUFFER_SAVE);
/**
 * @param {number} rawAssetId
 */

export function save(rawAssetId) {
  return (dispatch, getState) => {
    const state = getState();
    const asset = getRawAsset(state, {
      rawAssetId
    });
    dispatch(saveMessage(rawAssetId));
    return client.save(rawAssetId, asset).then(rawAsset => {
      return dispatch(saveMessage(rawAssetId, {
        rawAsset
      }));
    }).catch(error => {
      dispatch(saveMessage(rawAssetId, {
        error
      }));
    });
  };
}
const saveByPathMessage = messageFactory(RAW_ASSET_BUFFER_SAVE_BY_PATH);
/**
 * @param {string} rawAssetId
 */

export function saveByPath(rawAssetId) {
  return (dispatch, getState) => {
    const state = getState();
    const asset = getRawAsset(state, {
      rawAssetId
    });
    dispatch(saveByPathMessage(rawAssetId));
    client.saveByPath(asset.path, asset, {
      query: {
        environmentId: STAGED
      }
    }).then(rawAsset => {
      dispatch(saveByPathMessage(rawAssetId, {
        rawAsset,
        rawAssetBuffer: asset
      }));
      dispatch(addStagedFile(asset, rawAsset));
    }).catch(error => {
      dispatch(saveByPathMessage(rawAssetId, {
        error
      }));
    });
  };
}
/**
 * @param {number} rawAssetId
 * @param {CodeEditorError} error
 */

export function jsonLint(rawAssetId, error) {
  return {
    type: RAW_ASSET_BUFFER_JSON_LINT,
    rawAssetId,
    error
  };
}
/**
 *  Updates the upload progress of a raw asset replcement
 *
 *  @param {number} rawAssetId
 *  @param {number} progress
 */

export const updateUploadProgress = (rawAssetId, progress) => ({
  type: RAW_ASSET_UPDATE_UPLOAD_PROGRESS,
  rawAssetId,
  progress
});

const requestReplace = (rawAssetId, objectUrl) => ({
  type: RAW_ASSET_BUFFER_REPLACE,
  rawAssetId,
  objectUrl
});

const receiveReplace = (rawAssetId, rawAsset) => ({
  type: RAW_ASSET_BUFFER_REPLACE,
  rawAssetId,
  rawAsset
});

const errorReplace = (rawAssetId, error) => ({
  type: RAW_ASSET_BUFFER_REPLACE,
  rawAssetId,
  error
});
/**
 *  Replaces the raw asset
 *
 *  @param {object} rawAsset
 *  @param {File} file
 */


export const replace = (rawAsset, file) => {
  return dispatch => {
    if (!rawAsset || !rawAsset.id || !file) {
      return;
    }

    try {
      const objectUrl = window.URL.createObjectURL(file);
      dispatch(requestReplace(rawAsset.id, objectUrl));
    } catch (error) {
      dispatch(errorReplace(rawAsset.id, error));
      return;
    }

    const extension = file.name.split('.').pop();

    if (rawAsset.extension !== extension) {
      dispatch(errorReplace(rawAsset.id, DIFFERENT_FILE_EXTENSION));
      return;
    }

    const handleProgress = e => {
      const progress = e.loaded / e.total * 100;
      dispatch(updateUploadProgress(rawAsset.id, progress));
    };

    client.replace(rawAsset.path, file, handleProgress).then(updatedRawAsset => {
      dispatch(receiveReplace(rawAsset.id, updatedRawAsset));
    }, err => {
      dispatch(errorReplace(rawAsset.id, err));
    });
  };
};

const requestFetchRevision = (rawAssetId, revisionId) => ({
  type: RAW_ASSET_REVISION_FETCH,
  rawAssetId,
  revisionId
});

const receiveFetchRevision = (rawAssetId, revisionId, rawAsset) => ({
  type: RAW_ASSET_REVISION_FETCH,
  resourceId: rawAssetId,
  revisionId,
  rawAsset
});

const errorFetchRevision = (rawAssetId, revisionId, err) => ({
  type: RAW_ASSET_REVISION_FETCH,
  rawAssetId,
  revisionId,
  error: err
});
/**
 *  Fetches the versioned raw asset
 *
 *  @param {number} rawAssetId
 *  @param {number} revisionId
 */


export function fetchRevision(rawAssetId, revisionId) {
  return (dispatch, getState) => {
    const state = getState();
    const rawAssetRevision = getRawAsset(state, {
      rawAssetId,
      revisionId
    });

    if (rawAssetRevision) {
      /**
       *  `api/RawAssetRevisions.fetchRawAssetRevisions` does not return source
       *  hydrated models. This is on purpose to avoid expensive s3 calls upfront
       *  (source data is hosted on s3).
       *
       *  When previewing a TEXT Raw Asset, the original Raw Asset instance needs to be
       *  replaced with the source hydrated instance from
       *  `api/RawAssetRevisions.fetchRawAssetRevision`.
       */
      const type = RawAssetExtensions[rawAssetRevision.extension || 'txt'].type;

      if (type !== TEXT) {
        return;
      }
    }

    dispatch(requestFetchRevision(rawAssetId));
    fetchRawAssetRevision(rawAssetId, revisionId).then(rawAsset => {
      dispatch(receiveFetchRevision(rawAssetId, revisionId, rawAsset));
    }, err => {
      dispatch(errorFetchRevision(rawAssetId, revisionId, err));
    });
  };
}

const receiveRevertRawAsset = (rawAssetId, rawAsset) => ({
  type: RAW_ASSET_REVERT,
  rawAssetId,
  rawAsset
});

const errorRevertRawAsset = (rawAssetId, error) => ({
  type: RAW_ASSET_REVERT,
  rawAssetId,
  error
});
/**
 *  Replaces the current buffer with a versioned raw asset
 *  @param {object} revision
 */


export function revertRawAsset(revision) {
  const rawAssetId = revision.object.id;
  return dispatch => {
    return revertRawAssetClient(rawAssetId, revision.id).then(rawAsset => {
      dispatch(receiveRevertRawAsset(rawAssetId, rawAsset));
    }, error => {
      dispatch(errorRevertRawAsset(rawAssetId, error));
    });
  };
}